import React from 'react';
import ReactDOM from 'react-dom/client'; // Notice this import change
import './index.css';
import App from './App';

// Create a root and render the app
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
